import React from "react";
import deepakSharmaImg from "../../assets/images/webp/other/deepak-sharma.webp";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";

const MeetDeepak = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center max-[992px]:flex-wrap-reverse gap-[67px] max-xl:gap-10 max-md:text-6 max-w-[1087px] mx-auto">
          <div className="w-full max-w-[523px]">
            <img
              src={deepakSharmaImg}
              alt="deepak-sharma"
              width={523}
              height={548}
              className="w-full pointer-events-none"
            />
          </div>
          <div className="w-full max-w-[559px] max-[992px]:max-w-full">
            <BlueTag>Meet Deepak Sharma</BlueTag>

            <Heading>
              The human body and mind are programmable – and water is the
              medium.
            </Heading>
            <p className="text-[#5E5C5C] text-[26px] max-md:text-base font-normal leading-[150%] pt-4">
              Deepak Sharma is not just an entrepreneur blending ancient wisdom,
              magnetic science, and Al-powered consciousness into revolutionary
              life-enhancing technologies. Starting from a humble background,
              Deepak Sharma has always belieef in one thing.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetDeepak;
